import {
  ArrowForwardRounded,
  EventAvailableRounded,
  RocketLaunchRounded
} from "@mui/icons-material";
import { Box, Button, Stack, Typography } from "@mui/material";
import { PageContainer, sectionSx } from "./SectionLayout";

export default function CtaSection({ onStartHiring }) {
  return (
    <Box id="get-started" component="section" sx={sectionSx}>
      <PageContainer
        sx={{
          maxWidth: { xs: "100%", md: "85%", xl: 1744 },
          px: { xs: 2, sm: 3, md: 0 }
        }}
      >
        <Box
          sx={{
            background:
              "radial-gradient(circle at 8% 0%, rgba(255,255,255,0.12), transparent 34%), linear-gradient(135deg, #6747df 0%, #5e3ed8 52%, #5837d1 100%)",
            borderRadius: { xs: 2, sm: 3, md: 4 },
            color: "common.white",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            minHeight: { xs: 500, sm: 440, md: 450, xl: 600 },
            overflow: "hidden",
            px: { xs: 2.5, sm: 5, md: 8 },
            py: { xs: 5.5, sm: 7, md: 8 },
            position: "relative",
            textAlign: "center"
          }}
        >
          <Box
            sx={{
              alignItems: "center",
              backdropFilter: "blur(8px)",
              bgcolor: "rgba(255,255,255,0.11)",
              border: "1px solid rgba(255,255,255,0.18)",
              borderRadius: 2.75,
              display: "flex",
              height: { xs: 72, sm: 78 },
              justifyContent: "center",
              mb: { xs: 3.5, sm: 4.5 },
              mx: "auto",
              width: { xs: 72, sm: 78 }
            }}
          >
            <RocketLaunchRounded sx={{ fontSize: { xs: 34, sm: 38 } }} />
          </Box>
          <Typography
            sx={{
              color: "#ffffff",
              fontSize: { xs: 15, sm: 17 },
              lineHeight: 0.8,
              mt: { xs: 2, sm: 2.5 }
            }}
          >
            Ready to Transform Your Hiring?
          </Typography>
          <Typography
            sx={{
              color: "rgba(255,255,255,0.76)",
              fontSize: { xs: 15, sm: 17 },
              lineHeight: 1.7,
              mt: { xs: 2, sm: 2.5 }
            }}
          >
            Join thousands of companies and candidates growing with NextHire.
          </Typography>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent="center"
            spacing={2}
            sx={{ mt: { xs: 4, sm: 5 }, width: { xs: "100%", sm: "auto" } }}
          >
            <Button
              variant="contained"
              onClick={onStartHiring}
              endIcon={<ArrowForwardRounded />}
              sx={{
                bgcolor: "common.white",
                color: "primary.main",
                fontSize: 14,
                minHeight: 50,
                minWidth: { sm: 220 },
                px: 3,
                transition: "background-color 180ms ease, transform 180ms ease",
                width: { xs: "100%", sm: "auto" },
                "&:hover": {
                  bgcolor: "#f3efff",
                  transform: "scale(1.03)"
                }
              }}
            >
              Start Hiring Now
            </Button>
            <Button
              component="a"
              href="https://www.reyan.co.in/contact-us.php"
              rel="noreferrer"
              target="_blank"
              variant="contained"
              endIcon={<EventAvailableRounded />}
              sx={{
                bgcolor: "#4c21c5",
                boxShadow: "none",
                color: "common.white",
                fontSize: 14,
                minHeight: 50,
                minWidth: { sm: 205 },
                px: 3,
                transition: "background-color 180ms ease, transform 180ms ease",
                width: { xs: "100%", sm: "auto" },
                "&:hover": {
                  bgcolor: "rgba(255,255,255,0.11)",
                  boxShadow: "none",
                  transform: "scale(1.03)"
                }
              }}
            >
              Book a Demo
            </Button>
          </Stack>
        </Box>
      </PageContainer>
    </Box>
  );
}
